<div class="version-dialog-container">
  <!-- Modal Header -->
  <div class="modal-header">
    <h2 class="modal-title">New Version</h2>
    <button
      mat-icon-button
      class="close-button"
      (click)="onCancel()"
      aria-label="Close"
    >
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Subtitle section -->
  <div class="dialog-subtitle">
    <p class="latest-version">
      The latest version is
      <span class="version-number">{{ latestVersion() }}</span
      >.
    </p>
    <p class="suggestion-text">
      Use the suggested numbering or enter your own values
    </p>
  </div>

  <form [formGroup]="versionForm" (ngSubmit)="onSubmit()">
    <div mat-dialog-content class="dialog-content">
      <div class="form-content">
        <div class="version-inputs">
          <mat-form-field appearance="outline" class="form-field major-version">
            <mat-label>Major Version</mat-label>
            <input
              matInput
              type="number"
              formControlName="majorVersion"
              min="0"
              required
            />
            @if (versionForm.get("majorVersion")?.hasError("required")) {
              <mat-error> Major version is required </mat-error>
            }
            @if (versionForm.get("majorVersion")?.hasError("min")) {
              <mat-error> Major version must be a positive number </mat-error>
            }
          </mat-form-field>

          <span class="version-separator">.</span>

          <mat-form-field appearance="outline" class="form-field minor-version">
            <mat-label>Minor version</mat-label>
            <input
              matInput
              type="number"
              formControlName="minorVersion"
              min="0"
              required
            />
            @if (versionForm.get("minorVersion")?.hasError("required")) {
              <mat-error> Minor version is required </mat-error>
            }
            @if (versionForm.get("minorVersion")?.hasError("min")) {
              <mat-error> Minor version must be a positive number </mat-error>
            }
          </mat-form-field>
        </div>

        <mat-form-field appearance="outline" class="form-field version-message">
          <mat-label>Message (optional)</mat-label>
          <textarea
            matInput
            formControlName="message"
            rows="3"
            [maxlength]="MESSAGE_MAX_LENGTH"
            placeholder="Describe what changed in this version"
          ></textarea>
          @if (versionForm.get("message")?.hasError("maxlength")) {
            <mat-error>
              Message must be {{ MESSAGE_MAX_LENGTH }} characters or fewer
            </mat-error>
          }
        </mat-form-field>
      </div>
    </div>

    <div mat-dialog-actions class="dialog-actions">
      <button
        type="button"
        class="cancel-button"
        (click)="onCancel()"
        [disabled]="isLoading()"
      >
        Cancel
      </button>
      <button
        class="create-button"
        type="submit"
        [disabled]="versionForm.invalid || isLoading()"
      >
        {{ isLoading() ? "Creating..." : "Create" }}
      </button>
    </div>
  </form>
</div>
